import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Mitch Berninger
 * id EF46E7D8-3062-41E5-8FC6-92D66DEF7603
 * name folder-home
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-home.svg
 * tags
 * - Files / Folders 
 * - Home Automation 
 */
export const FolderHomeIcon = createSvgIcon(<><path d="M20 6H12L10 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V8A2 2 0 0 0 20 6M17 13V17H15V14H13V17H11V13H9L14 9L19 13Z" /></>, 'FolderHomeIcon');
export default FolderHomeIcon